import React from "react";
import { Star } from "lucide-react";

/** "Destacado": the athlete's plan includes a highlighted profile (DEV-43).
 *  A label only — it never changes how results are ordered. */
const FeaturedBadge = ({ className = "" }) => (
  <span
    className={`inline-flex shrink-0 items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-800 ${className}`}
    title="Perfil destacado"
  >
    <Star size={10} fill="currentColor" aria-hidden="true" />
    Destacado
  </span>
);

export default FeaturedBadge;
